import React, { useEffect, useState } from "react";
import {useNavigate,useLocation } from "react-router-dom";
import MRList from "./MRList";
import MRDetailsFile from "./materialRequirementDetails";
import MRVendorsModal from "./MRVendorsModal";
import MRMaterialsAndResponses from "./MRMaterialsAndResponses"; // ✅ new component
import {
  Msg200or201,
  Msg204,
  Msg400,
  Msg401,
  Msg403,
  Msg500,
} from "../Messages/Messages";
import {Loader} from '../Loader/Loader';
import { decryptData } from "../../utils/storageCrypto";

const MRRequirements = () => {
  // Local state for MRs
  const navigate = useNavigate();
  const location = useLocation();
  const [MRs, setMRs] = useState([]);
  const [selectedMRIndex, setSelectedMRIndex] = useState(); // default first
  const [showVendorsModal, setShowVendorsModal] = useState(false);
    const [error, setError] = useState(""); // Optional: For error display
  const [isLoading, setIsLoading] = useState(true); // Optional: Loading state
  const [TotalVendors, setTotalVendors] = useState([]); // Total vendors for selected MR
  const selectedMR = MRs[selectedMRIndex] || null;
  const [MRDetails, setMRDetails] = useState([]); // Vendor responses for selected MR
  const [MRitems, setMRitems] = useState([]); // Vendor responses for selected MR
   const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("");
    const [isSaving, setIsSaving] = useState(false);
   const [retryFunction, setRetryFunction] = useState(null);

  useEffect(() => {
    if (!showPopup) return;

    const autoCloseTypes = ["200or201", "204"];
    if (!autoCloseTypes.includes(popupType)) return;

    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [showPopup, popupType]);

 console.log("selectedMR:", selectedMR);
 const handleSelectMR = async (MR, index) => {
   await getVendorsByProductCategoryIds(MR); // Fetch vendors for selected MR
   await getMritemsByMrid(MR._id)
   //await getSupplierResponsesForMR(MR); // Fetch vendor responses for selected MR
   setSelectedMRIndex(index);
    if (MR?._id) {
        
      // Update URL with MRid as query param
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("MRid", MR._id);

      navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
    }
  };

  // Update vendors for a given MR (from modal)
  const handleSaveVendorsForMR = async (MR, newVendorIds) => {
  const VendorsUpdated = await UpdateVendorsForMR(MR._id, newVendorIds); 
  if (!VendorsUpdated) {
    setError("Failed to update vendors. Please try again.");
    return;
  }else{
 setMRs((prev) =>
      prev.map((r) =>
        r._id === MR._id ? { ...r, vendor_ids: [...newVendorIds] } : r
      )
    );
   selectedMR.vendor_ids = newVendorIds; // Update local selectedMR as well
    setShowVendorsModal(false);
  }
   
  };

  const getMritemsByMrid = async (mrid)=>{
    if (!mrid) {
    console.error("Invalid mrid selected:", );
    setError("Invalid MR selected.");
    return;
  }
      const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);

  if (!token) {
    console.warn("Authentication token missing.");
    setError("Authentication required. Please log in again.");
    return;
  }
 const URL = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/material-requirement/get-mritems-by-mr-id?mrId=${mrid}`;

 try {
    const response = await fetch(URL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    if (!response.ok) {
      setMRitems([])
      throw new Error(`Server returned status ${response.status}`);
    }
    console.log(response)
    let data;
    try {
      data = await response.json();
    } catch (jsonError) {
      setMRitems([])
      console.error("Failed to parse JSON response:", jsonError);
      throw new Error("Invalid server response format.");
    }
    console.log(data)
    // Check for expected structure
    if (!data || !data.data) {
      console.warn("Unexpected response structure:", data);
      setMRitems([])
      return;
    }
   setMRitems(data.data)
  } catch (error) {
    setMRitems([])
    console.error("Error fetching Vendor Responses:", error);
    setError(error.message || "Failed to load Vendor Responses.");
  }
  finally {
    setIsLoading(false); 
  }
  }



  const getSupplierResponsesForMR = async (MR) => {
  if (!MR || !MR._id) {
    console.error("Invalid MR selected:", MR);
    setError("Invalid MR selected.");
    return;
  }

      const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);

  if (!token) {
    console.warn("Authentication token missing.");
    setError("Authentication required. Please log in again.");
    return;
  }

  const URL = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/MR/get-all-MR-vendor-responses-by-MR?MR_id=${MR._id}`;

  try {
    const response = await fetch(URL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    if (!response.ok) {
      console.warn(`Failed fetch: HTTP ${response.status}`);
      setMRDetails({ requirements: [], responses: [] }); // Clear details on error
      throw new Error(`Server returned status ${response.status}`);
    }

    let data;
    try {
      data = await response.json();
    } catch (jsonError) {
      console.error("Failed to parse JSON response:", jsonError);
      throw new Error("Invalid server response format.");
    }

    // Check for expected structure
    if (!data || !data.data) {
      console.warn("Unexpected response structure:", data);
      setMRDetails({ requirements: [], responses: [] });
      return;
    }

    // Safely update state
    setMRDetails(data.data);
    //console.log("Vendor Responses updated successfully:", data.data);

  } catch (error) {
    console.error("Error fetching Vendor Responses:", error);
    setError(error.message || "Failed to load Vendor Responses.");
  }
};


  const UpdateVendorsForMR = async (MRId, vendorIds) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      if (!token) {
        setError("Authentication required. Please log in again.");
        return;
      }
      const URL = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/MR/update-MR`;
      const response = await fetch(URL, {
        method: "PUT", 
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify({ _id: MRId, vendor_ids: vendorIds }),
      });
      //console.log("Updating MR Vendors with:", { MR_id: MRId, vendor_ids: vendorIds });    
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      //console.log("Update response data:", data);
      if (data.success) {
       return true;
      } else {
        setError(data.message || "Failed to update vendors.");
      }   
    } catch (error) {
      console.error("Error updating MR vendors:", error);
      setError(error.message || "Failed to update vendors.");
    }
  };

  // Fetch MRs on mount



  useEffect(() => {
    HandleGetAllMRs();
  }, []); // Runs once on mount


  // Corrected handler (place outside component or use useCallback if needed)
  const HandleGetAllMRs = async (MR=null) => {
    setIsLoading(true); // Start loading
    try {
            const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      if (!token) {
        setError("Authentication required. Please log in again.");
        return;
      }

      const URL = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/material-requirement/get-all-customers-material-requirements`;
      const response = await fetch(URL, {
        method: "GET",
        headers: {
        'Content-Type': 'application/json',
        'x-token': token
        },
      });
     console.log("Fetching MRs from:", response);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      } 

      const data = await response.json();
      console.log("data:",data)
      if (data.data && Array.isArray(data.data)) {
       setMRs(data.data);
        if (data.data && data.data.length > 0) {
  // Check if URL contains "MRid" query parameter
  const searchParams = new URLSearchParams(location.search);
  const MRIdFromURL = searchParams.get("MRid");

  if (MR) {
    const index = data.data.findIndex(r => r._id === MR._id);
    if (index !== -1) {
      console.log("Selecting MR from URL:", data.data[index]);
      handleSelectMR(data.data[index], index); // Select MR from URL
    } else {
      handleSelectMR(MR); // Fallback: select first MR
    }
  } else {
    handleSelectMR(data.data[0], 0); // Default: select first MR
  }
}

      } else {
        console.warn("Unexpected response format");
       // setMRs([]);
        setError("Invalid response from server.");
      }
    } catch (error) {
      console.error("Error fetching MRs:", error);
      setError(error.message || "Failed to load MRs.");
      //setMRs([]);
    } finally {
      setIsLoading(false); // Always stop loading
    }
  };
 
  const getVendorsByProductCategoryIds = async (MR) => {
  if (!MR || !MR.product_category_ids || !Array.isArray(MR.product_category_ids)) {
    setError("No product categories found for the selected MR.");
    return;
  }
  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    if (!token) {
      setError("Authentication required. Please log in again.");
      return;
    }

    // Ensure product_category_ids are strings
    const categoryIds = MR.product_category_ids.map((id) => id._id.toString());

    // Send as comma-separated query param
    const URL = `${process.env.REACT_APP_FORE_BRICKBUCKET}vendor/get-vendors-by-product-category-ids?product_category_ids=${categoryIds.join(",")}`;

    const response = await fetch(URL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

   // console.log("Fetching Vendors from:", URL);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    //console.log("Vendors response data:", data);

    if (data.data && Array.isArray(data.data)) {
     setTotalVendors(data.data);
    } else {
      console.warn("Unexpected response format for vendors");
      setError("Invalid response from server.");
    }
  } catch (error) {
    console.error("Error fetching Vendors:", error);
    setError(error.message || "Failed to load Vendors.");
  }
};

// Close popup handler
  const closePopup = () => {
    setShowPopup(false);
  };

  // Retry handler
  const retry = async () => {
    setShowPopup(false);
    if (retryFunction) {
      setIsSaving(true);
      await retryFunction();
      setIsSaving(false);
    }
  };

    const backToLoginPage = () => {
    setShowPopup(false);
    localStorage.removeItem("LoginData");
    sessionStorage.removeItem("userData");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("appId");
    navigate("/admin");
  };


  // Render with loading/error handling
 if (isLoading) {
  return <Loader />;
}

  return (
    <div className="h-screen flex flex-col">
      {/* ✅ Top Fixed Section */}
      <div className="bg-white border-b shadow-sm">
        {selectedMR ? (
          <MRDetailsFile
            MR={selectedMR}
            onOpenVendors={() => {setShowVendorsModal(true);}}
            Vendors= {TotalVendors}
            onValidate={() => alert(`Validate ${selectedMR.MR_number}`)}
            onGetQuotes={() => alert(`Get quotes for ${selectedMR.MR_number}`)}
            onUpload={() =>
              alert(`This Future Not intigrated with api`)
            }
            FetchMRs={HandleGetAllMRs}
            setPopupType={setPopupType}
            setMRStatusMessage= {setPopupMessage}
            setShowPopup = {setShowPopup}
          />
        ) : (
          <div className="p-4 text-gray-500">Select an MR to view details</div>
        )}
      </div>

      {/* ✅ Bottom Section (split layout) */}
      <div className="flex-1 flex overflow-hidden">
        {/* Left - MR List */}
        <div className="w-80 bg-white border-r overflow-y-auto">
          <MRList
            MRs={MRs}
            selectedIndex={selectedMRIndex}
            onSelectMR={handleSelectMR}
          />
        </div>

        {/* Right - Materials + Vendor Responses */}
        <div className="flex-1 overflow-auto p-2 bg-gray-50 ">
           {selectedMR ? (
            <MRMaterialsAndResponses MR={selectedMR} 
            allVendors={TotalVendors} 
            assignedVendorIds={
  Array.isArray(selectedMR?.vendor_ids)
    ? selectedMR.vendor_ids
        .map((v) => (typeof v === "object" ? v._id : v)) // handles both object and string cases
        .filter(Boolean) // remove null/undefined/empty
    : []
}
MRDetails={MRDetails}
MRItems = {MRitems}
fetchMrItems = {getMritemsByMrid}
 setPopupType={setPopupType}
 setMRItemsPoupMessage= {setPopupMessage}
 setShowPopup = {setShowPopup}
/>
          ) : (
            <p className="text-gray-500">Select an MR to see details.</p>
          )} 
        </div>
      </div>

      {/* ✅ Vendors Modal */}
      {showVendorsModal && selectedMR && (
        <MRVendorsModal
          isOpen={showVendorsModal}
          onClose={() => setShowVendorsModal(false)}
          allVendors={TotalVendors}
          assignedVendorIds={
  Array.isArray(selectedMR?.vendor_ids)
    ? selectedMR.vendor_ids
        .map((v) => (typeof v === "object" ? v._id : v)) // handles both object and string cases
        .filter(Boolean) // remove null/undefined/empty
    : []
}

          MRNumber={selectedMR.MR_number}
          onSave={(newIds) =>
            handleSaveVendorsForMR(selectedMR, newIds)
          }
        />
      )}

     {showPopup && (
              <div >
                  {popupType === "200or201" && (
                    <Msg200or201 message={popupMessage} timeout={3000} />
                  )}
                  {popupType === "204" && (
                    <Msg204 message={popupMessage} timeout={3000} />
                  )}
                  {popupType === "400" && (
                    <Msg400 message={popupMessage} closePopup={closePopup} />
                  )}
                  {popupType === "401" && (
                    <Msg401 message={popupMessage} closePopup={closePopup} />
                  )}
                  {popupType === "403" && (
                    <Msg403 message={popupMessage} closePopup={backToLoginPage} />
                  )}
                  {popupType === "500" && (
                    <Msg500
                      message={popupMessage}
                      closePopup={retry}
                      cancelPopup={closePopup}
                    />
                  )}
                
              </div>
            )}
      
    </div>
  );
};

export default MRRequirements;
